import { ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ControlToKeyNamePipe } from '@shared/form-elements/pipes/control-to-key-name.pipe';

@Component({
    selector: 'app-selection-thumb',
    templateUrl: './selection-thumb.component.html',
    styleUrls: ['./selection-thumb.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, ReactiveFormsModule, ControlToKeyNamePipe]
})
export class SelectionThumbComponent {
    public style: Partial<CSSStyleDeclaration>;

    @ViewChild('label') label: ElementRef<HTMLElement>;
    @Input() control: AbstractControl;
    @Input() id: string = '';
    @Input() value: any;
    @Input() name = '';
    @Input() required = false;
    @Input() checked = false;
    @Input() set disabled(value: boolean) {
        if (value) {
            this.formControl.disable();
        } else {
            this.formControl.enable();
        }
    }

    public get formControl(): UntypedFormControl {
        return this.control as UntypedFormControl;
    }
}
